import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import vodAdapter from 'shared/utils/adapters/vod';

import { normalizeArrayOfVideos } from 'shared/redux/helpers/normalized';


const ACTIONS = createAsyncActions('SERVER.VIDEOS.UPDATE');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;

export { SUCCESS };


export default function (videosIds, data) {
  return function (dispatch) {
    const normalizedData = normalizeArrayOfVideos(
      _.map(videosIds, videoId => ({
        id: videoId,
        // don't update dealInfo before request is sent
        ..._.omit(data, 'dealInfo'),
      }))
    );

    dispatch(START(data, { data: normalizedData }));

    return vodAdapter.items.update(videosIds, data)
      .then(
        function (response) {
          const params = { videosIds };

          response = {
            ...response,
            data: normalizeArrayOfVideos(response.data),
          };

          dispatch(SUCCESS(params, response));
          return response;
        },

        function (error) {
          dispatch(FAIL(data, null, { analytics: { type: 'error', name: 'dashboard.videos.update' } }));
          return error;
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/dashboard/redux/server/actions/videos/update.js